/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.$ = window.jQuery = require('jquery');
require('datatables.net-bs4');


import router from './assets/router.js';
import Vue from "vue";
//import VueMeta from 'vue-meta';
import VueLazyload from 'vue-lazyload';
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';

Vue.component('inner-image-zoom', InnerImageZoom);

require('../../node_modules/bootstrap-select/dist/js/bootstrap-select.min');

window.Vue = require('vue');

  import loadingIcon from './../../public/spinner-solid.svg';
  import errorIcon from './../../public/exclamation-circle-solid.svg';

  Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: errorIcon,
    loading: loadingIcon,
    attempt: 1,
    observer: true, // Usa IntersectionObserver para mejorar el rendimiento
    observerOptions: {
      rootMargin: '0px',
      threshold: 0.1
    }
  });  

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */


// Importación dinámica de componentes
const components = {
    'modal-post': () => import(/* webpackChunkName: "modal-post" */ './components/PostModalComponent.vue'),
    'modal-busqueda': () => import(/* webpackChunkName: "modal-busqueda" */ './components/PostCategoryComponent.vue'),
    'post-list-default': () => import(/* webpackChunkName: "post-list-default" */ './components/PostListDefaultComponent.vue'),
    'input-rut': () => import(/* webpackChunkName: "input-rut" */ './components/ValidateRutComponent.vue'),
    'select-provincia-vehicle': () => import(/* webpackChunkName: "select-provincia-vehicle" */ './components/SelectProvinceVehicleComponent.vue'),
    'select-provincia': () => import(/* webpackChunkName: "select-provincia" */ './components/SelectProvinceComponent.vue'),
    'create-vehicle-post': () => import(/* webpackChunkName: "create-vehicle-post" */ './components/RegisterUserVehicleComponent.vue'),
    'create-post': () => import(/* webpackChunkName: "create-post" */ './components/RegisterUserComponent.vue'),
    'update-post': () => import(/* webpackChunkName: "update-post" */ './components/UpdateUserComponent.vue'),
    'update-post-vehicle': () => import(/* webpackChunkName: "update-post-vehicle" */ './components/UpdateUserVehicleComponent.vue'),
    'delivery-restriction': () => import(/* webpackChunkName: "delivery-restriction" */ './components/DeliveryRestrictionsComponent.vue'),
    'register-address': () => import(/* webpackChunkName: "register-address" */ './components/AddressComponent.vue'),
    'AroBicicleta': () => import(/* webpackChunkName: "AroBicicleta" */ './components/ArobicicletaComponent.vue'),
    'Genero': () => import(/* webpackChunkName: "Genero" */ './components/GeneroComponent.vue'),
    'Sexo': () => import(/* webpackChunkName: "Sexo" */ './components/SexoComponent.vue'),
    'raza': () => import(/* webpackChunkName: "raza" */ './components/RazaComponent.vue'),
    'titulo': () => import(/* webpackChunkName: "titulo" */ './components/TituloComponent.vue'),
    'evento': () => import(/* webpackChunkName: "evento" */ './components/EventoComponent.vue'),
    'artista': () => import(/* webpackChunkName: "artista" */ './components/ArtistaComponent.vue'),
    'formato': () => import(/* webpackChunkName: "formato" */ './components/FormatoComponent.vue'),
    'idioma': () => import(/* webpackChunkName: "idioma" */ './components/IdiomaComponent.vue'),
    'localidad': () => import(/* webpackChunkName: "localidad" */ './components/LocalidadComponent.vue'),
    'color': () => import(/* webpackChunkName: "color" */ './components/ColorComponent.vue'),
    'altura': () => import(/* webpackChunkName: "localidad" */ './components/AlturaComponent.vue'),
    'cortaCorriente': () => import(/* webpackChunkName: "cortaCorriente" */ './components/Corta_CorrienteComponent.vue'),
    'cantidadNeumaticos': () => import(/* webpackChunkName: "cantidadNeumaticos" */ './components/CantidadneumaticoComponent.vue'),
    'diametro': () => import(/* webpackChunkName: "diametro" */ './components/DiametroComponent.vue'),
    'edad': () => import(/* webpackChunkName: "edad" */ './components/EdadComponent.vue'),
    'estilo': () => import(/* webpackChunkName: "estilo" */ './components/EstiloComponent.vue'),
    'ancho': () => import(/* webpackChunkName: "ancho" */ './components/AnchoComponent.vue'),
    'indiceCarga': () => import(/* webpackChunkName: "indiceCarga" */ './components/Indice_CargaComponent.vue'),
    'indiceVelocidad': () => import(/* webpackChunkName: "indiceVelocidad" */ './components/Indice_VelocidadComponent.vue'),
    'lado': () => import(/* webpackChunkName: "lado" */ './components/LadoComponent.vue'),
    'largo': () => import(/* webpackChunkName: "largo" */ './components/LargoComponent.vue'),
    'marca': () => import(/* webpackChunkName: "marca" */ './components/MarcaComponent.vue'),
    'material': () => import(/* webpackChunkName: "material" */ './components/MaterialComponent.vue'),
    'materialExterior': () => import(/* webpackChunkName: "materialExterior" */ './components/MaterialExteriorComponent.vue'),
    'materialInterior': () => import(/* webpackChunkName: "materialInterior" */ './components/MaterialInteriorComponent.vue'),
    'materialjoya': () => import(/* webpackChunkName: "materialjoya" */ './components/MaterialjoyaComponent.vue'),
    'posicion': () => import(/* webpackChunkName: "posicion" */ './components/PosicionComponent.vue'),
    'sensorPresencia': () => import(/* webpackChunkName: "sensorPresencia" */ './components/Sensor_PresenciaComponent.vue'),
    'sirena': () => import(/* webpackChunkName: "sirena" */ './components/SirenaComponent.vue'),
    'tamano': () => import(/* webpackChunkName: "tamano" */ './components/TamanoComponent.vue'),
    'tamanoPantalla': () => import(/* webpackChunkName: "tamanoPantalla" */ './components/Tamano_PantallaComponent.vue'),
    'tallaBebe': () => import(/* webpackChunkName: "tallaBebe" */ './components/TallabebeComponent.vue'),
    'tallaCalzado': () => import(/* webpackChunkName: "tallaCalzado" */ './components/TallacalzadoComponent.vue'),
    'tallaRopa': () => import(/* webpackChunkName: "tallaRopa" */ './components/TallaropaComponent.vue'),
    'tipoCasco': () => import(/* webpackChunkName: "tipoCasco" */ './components/TipocascoComponent.vue'),
    'tipoMontaje': () => import(/* webpackChunkName: "tipoMontaje" */ './components/TipomontajeComponent.vue'),
    'transductor': () => import(/* webpackChunkName: "transductor" */ './components/TransductorComponent.vue'),
    'unidadPorEnvase': () => import(/* webpackChunkName: "unidadPorEnvase" */ './components/Unidad_por_EnvaseComponent.vue'),
    'volumen': () => import(/* webpackChunkName: "volumen" */ './components/VolumenComponent.vue'),
    'voltaje': () => import(/* webpackChunkName: "voltaje" */ './components/VoltajeComponent.vue'),
    'delivery-chart': () => import(/* webpackChunkName: "delivery-chart" */ './components/ChartComponent.vue'),
    'archivo': () => import(/* webpackChunkName: "archivo" */ './components/ArchivoComponent.vue'),
    'search': () => import(/* webpackChunkName: "search" */ './components/SearchComponent.vue'),
    'puja': () => import(/* webpackChunkName: "puja" */ './components/PujaComponent.vue'),
    'pujas': () => import(/* webpackChunkName: "pujas" */ './components/PujaListComponent.vue'),
    'oferta-vehiculos': () => import(/* webpackChunkName: "oferta-vehiculos" */ './components/OfertaVehiculoListComponent.vue'),
    'compras': () => import(/* webpackChunkName: "compras" */ './components/CompraListComponent.vue'),
    'toast-question': () => import(/* webpackChunkName: "toast-question" */ './components/ToastQuestionComponent.vue'),
    'countdown': () => import(/* webpackChunkName: "countdown" */ './components/CountdownComponent.vue'),
    'posts-related': () => import(/* webpackChunkName: "posts-related" */ './components/PostsrelatedComponent.vue'),
    'categories-posts': () => import(/* webpackChunkName: "categories-posts" */ './components/CategoriesPostsComponent.vue'),
    'posts-related-home': () => import(/* webpackChunkName: "posts-related-home" */ './components/PostsrelatedhomeComponent.vue'),
    //vehicles
    'airbag': () => import(/* webpackChunkName: "airbag" */ './components/AirbagComponent.vue'),
    'aire_acondicionado': () => import(/* webpackChunkName: "aire_acondicionado" */ './components/Aire_acondicionadoComponent.vue'),
    'vidrio_electrico': () => import(/* webpackChunkName: "vidrio_electrico" */ './components/Vidrio_electricoComponent.vue'),
    'numero_puerta': () => import(/* webpackChunkName: "numero_puerta" */ './components/Numero_puertaComponent.vue'),
    'potencia_moto': () => import(/* webpackChunkName: "potencia_moto" */ './components/Potencia_motoComponent.vue'),
    'peso_moto': () => import(/* webpackChunkName: "peso_moto" */ './components/Peso_motoComponent.vue'),
    'publicidad': () => import(/* webpackChunkName: "publicidad" */ './components/PublicidadComponent.vue'),
    'whatsapp': () => import(/* webpackChunkName: "whatsapp" */ './components/WhatsAppComponent.vue'),
    'generic-dropdown': () => import(/* webpackChunkName: "generic-dropdown" */ './components/GenericDropdownComponent.vue'),
    'adsense': () => import(/* webpackChunkName: "adsense" */ './components/AdSenseComponent.vue'),
    'adsense-list': () => import(/* webpackChunkName: "adsense-list" */ './components/AdSenseListComponent.vue'),
};

// Registro de componentes globalmente usando importación dinámica
Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
});

//require('./province');
import auth from './mixins/auth';
//import { vue } from 'laravel-mix';
Vue.mixin(auth);
import SearchComponete from './components/SearchComponent'
var app = new Vue({
    components:{
        SearchComponete
    },
    el: "#app",
    methods: {
        async iniciarPago(id_sale,comision) {
            try {
                // Muestra el mensaje de "Cargando" utilizando SweetAlert
                this.$swal.fire({
                    title: 'Cargando...',
                    html: 'Serás redirigido a la pantalla de pago <i class="far fa-smile-wink fa-2x text-success"></i>',
                  didOpen: () => {
                      this.$swal.showLoading();
                  }
                });
                // Aquí puedes definir la lógica que se ejecutará al hacer clic en el botón
                axios.get('/api/iniciar_compra',{
                    params: {
                    id_sale: id_sale,
                    comision: comision
                    }
                }).then(response=>{
                    //this.$swal.stopLoading();
                    let url_pago = response.data;
                    window.location.href = url_pago;
                });                
            }   
            catch (error) {
                // Si ocurre un error, también cierra el mensaje de "Cargando"
                //this.$swal.stopLoading();
          
                // Muestra un mensaje de error utilizando SweetAlert
                this.$swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Ocurrió un error al intentar cargar la pantalla de pago, por favor inténtalo nuevamente.',
                });
            } 
        }
    },
    mounted: function () {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="offcanvas"], #navToggle').on('click', function () {
            $('.offcanvas-collapse-r').removeClass('open');
            $('.offcanvas-collapse').toggleClass('open');
            if (!$('.offcanvas-collapse').hasClass('open')) {    
                $('.offcanvas-backdrop').removeClass('open');
            }else{
                $('.offcanvas-backdrop').addClass('open');
            }
        });
        $('[data-toggle="offcanvas-r"], #navToggle').on('click', function () {
            $('.offcanvas-collapse').removeClass('open');
            $('.offcanvas-collapse-r').toggleClass('open');
            if (!$('.offcanvas-collapse-r').hasClass('open')) {    
                $('.offcanvas-backdrop').removeClass('open');
            }else{
                $('.offcanvas-backdrop').addClass('open');
            }
        });
        $('#product-carousel').carousel({ interval: false });
        $('.img-thumbnail').on('click', function (e) {
            e.preventDefault();
            $("#product-carousel").carousel(parseInt($(this).attr('data-image')) - 1);
        });
        $("#product-link").click(function () {
            $(this).select();
        });

        if (this.$el.dataset.usuario){
            this.usuario = JSON.parse(this.$el.dataset.usuario);
            console.log('Este es el usuario: '+this.usuario.ban_sell);
        }
        
    },
    router
});
